var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeroTrust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2038 21.3234C21.0659 19.3545 21.3502 17.3794 22.039 15.5213C22.7278 13.6632 23.8063 11.9621 25.207 10.5241C26.6078 9.08617 28.3008 7.9423 30.1803 7.16393C32.0598 6.38556 34.0855 5.98941 36.1308 6.00022C38.1761 6.01102 40.1971 6.42855 42.0677 7.22673C43.9382 8.02491 45.6182 9.18659 47.0025 10.6392C48.3869 12.0919 49.446 13.8043 50.1136 15.6696C50.7813 17.5348 51.0432 19.5129 50.883 21.4802L45.1376 21.0447C45.2358 19.8393 45.0753 18.6274 44.6662 17.4846C44.2572 16.3418 43.6083 15.2927 42.7601 14.4026C41.912 13.5126 40.8827 12.8009 39.7367 12.3119C38.5906 11.8228 37.3523 11.567 36.0992 11.5604C34.8461 11.5538 33.605 11.7965 32.4535 12.2734C31.302 12.7503 30.2647 13.4511 29.4065 14.3321C28.5482 15.2131 27.8875 16.2554 27.4655 17.3938C27.0435 18.5322 26.8693 19.7423 26.9537 20.9486L21.2038 21.3234Z",
    fill: "#F30002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4724 26.2397C11.492 45.8373 21.3002 59.4508 36.1493 66.0041C51.0654 59.26 59.723 45.9314 58.7042 26.3126C43.5157 21.5572 28.5613 21.4574 13.4724 26.2397ZM41.6781 35.8176C41.6781 38.1318 40.276 40.1186 38.2749 40.9746C41.3519 41.9392 43.5843 44.813 43.5843 48.2082C43.5843 48.4107 43.5608 48.8098 43.5608 48.8098H28.4493C28.4493 48.8098 28.4258 48.4107 28.4258 48.2082C28.4258 44.7844 30.6959 41.8909 33.813 40.9507C31.8413 40.082 30.4648 38.1105 30.4648 35.8176C30.4648 32.7211 32.975 30.2109 36.0715 30.2109C39.1679 30.2109 41.6781 32.7211 41.6781 35.8176Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroTrust);
export default __webpack_public_path__ + "static/media/Zero-Trust.0371d88480aea7784f507fcd29e04d1c.svg";
export { ForwardRef as ReactComponent };